import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { PROJECT } from '@app/tokens'

@Component({
  selector: 'app-logo',
  standalone: true,
  templateUrl: './logo.component.svg',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
  readonly project = inject(PROJECT)
}
